/**
 * Shared form reducer used by both Questionnaire and Editor contexts
 * Handles all form state updates in a consistent way
 */

import { QuestionnaireFormData, FormAction, initialFormData } from './SharedFormTypes';

/**
 * Form reducer - handles all form data updates
 * @param state - Current form state
 * @param action - Action to perform
 * @returns Updated form state
 */
export const formReducer = (state: QuestionnaireFormData, action: FormAction): QuestionnaireFormData => {
    switch (action.type) {
        case 'UPDATE_BASIC_INFO':
            return {
                ...state,
                basicInfo: {
                    ...state.basicInfo,
                    ...action.payload
                }
            };
        case 'UPDATE_MAIN_IMAGES':
            return {
                ...state,
                mainImages: {
                    ...state.mainImages,
                    ...action.payload
                }
            };
        case 'UPDATE_CEREMONY_LOCATION':
            return {
                ...state,
                ceremonyLocation: {
                    ...state.ceremonyLocation,
                    ...action.payload
                }
            };
        case 'UPDATE_WEDDING_LOCATION':
            return {
                ...state,
                weddingLocation: {
                    ...state.weddingLocation,
                    ...action.payload
                }
            };
        case 'UPDATE_GUESTS_FAQ':
            return {
                ...state,
                guestsFAQ: {
                    ...state.guestsFAQ,
                    ...action.payload
                }
            };
        case 'ADD_FAQ_ITEM':
            return {
                ...state,
                guestsFAQ: {
                    ...state.guestsFAQ,
                    faqs: [...state.guestsFAQ.faqs, action.payload],
                    selectedQuestionId: action.payload.id
                }
            };
        case 'UPDATE_FAQ_ANSWER':
            return {
                ...state,
                guestsFAQ: {
                    ...state.guestsFAQ,
                    faqs: state.guestsFAQ.faqs.map(faq =>
                        faq.id === action.payload.id
                            ? { ...faq, answer: action.payload.answer }
                            : faq
                    )
                }
            };
        case 'REMOVE_FAQ_ITEM':
            return {
                ...state,
                guestsFAQ: {
                    ...state.guestsFAQ,
                    faqs: state.guestsFAQ.faqs.filter(faq => faq.id !== action.payload),
                    selectedQuestionId: state.guestsFAQ.selectedQuestionId === action.payload 
                        ? null 
                        : state.guestsFAQ.selectedQuestionId
                }
            };
        case 'UPDATE_WITNESSES':
            return {
                ...state,
                witnesses: {
                    ...state.witnesses,
                    ...action.payload
                }
            };
        case 'UPDATE_CONTACT':
            return {
                ...state,
                contact: {
                    ...state.contact,
                    ...action.payload
                }
            };
        case 'UPDATE_DOMAIN':
            return {
                ...state,
                domain: {
                    ...state.domain,
                    ...action.payload
                }
            };
        case 'UPDATE_MENU':
            return {
                ...state,
                menu: {
                    ...state.menu,
                    ...action.payload
                }
            };
        case 'UPDATE_SCHEDULE':
            return {
                ...state,
                schedule: {
                    ...state.schedule,
                    ...action.payload
                }
            };
        case 'UPDATE_COLORS':
            return {
                ...state,
                colors: {
                    ...state.colors,
                    ...action.payload
                }
            };
        case 'UPDATE_TABLES':
            return {
                ...state,
                tables: {
                    ...state.tables,
                    ...action.payload
                }
            };
        case 'UPDATE_WEDDING_DETAILS':
            return {
                ...state,
                weddingDetails: {
                    ...state.weddingDetails,
                    ...action.payload
                }
            };
        case 'UPDATE_CURRENT_STEP':
            return {
                ...state,
                currentStep: action.payload
            };
        case 'LOAD_FROM_STORAGE':
            return action.payload;
        case 'RESET_FORM':
            return initialFormData;
        default:
            return state;
    }
};
